import React from 'react'
import { Button } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { useGetBusinessID } from '@marketing-milk/frontend'
import { useFeatureFlagEnabled } from 'posthog-js/react'
import { useScreenSize } from 'hooks/useScreenSize'
import { RecentImportsMenu } from './RecentImportsMenu'

export const CreativeImportButton = () => {
  const { isMobile } = useScreenSize()
  const history = useHistory()
  const businessID = useGetBusinessID()
  const creativeImportEnabled = useFeatureFlagEnabled('creative-import-enabled')

  if (process.env.NODE_ENV === 'production' && !creativeImportEnabled) return null

  // The recent-imports menu lives behind the same flag check, written once, so
  // the two can never disagree about visibility.
  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        onClick={() => history.push(`/${businessID}/creatives/import`)}
      >
        {isMobile ? '⬆' : 'Import Ads'}
      </Button>
      <RecentImportsMenu />
    </>
  )
}
